import { createActions } from 'redux-actions'

export const INIT_MASTER_BRAND_INFO = "INIT_CATEGORY_INFO";

export const REQUEST_MASTER_BRAND_START = "REQUEST_MASTER_BRAND_START";
export const REQUEST_MASTER_BRAND_SUCCESS = "REQUEST_MASTER_BRAND_SUCCESS";
export const REQUEST_ALL_MASTER_BRAND_SUCCESS = "REQUEST_ALL_MASTER_BRAND_SUCCESS";
export const REQUEST_MASTER_BRAND_FAIL = "REQUEST_MASTER_BRAND_FAIL";

export const POST_MASTER_BRAND_START = "POST_MASTER_BRAND_START";
export const POST_MASTER_BRAND_SUCCESS = "POST_MASTER_BRAND_SUCCESS";
export const POST_MASTER_BRAND_FAIL = "POST_MASTER_BRAND_FAIL";

export const PATCH_MASTER_BRAND_START = "PATCH_MASTER_BRAND_START";
export const PATCH_MASTER_BRAND_SUCCESS = "PATCH_MASTER_BRAND_SUCCESS";

export const DELETE_MASTER_BRAND_START = "DELETE_MASTER_BRAND_START";
export const DELETE_MASTER_BRAND_SUCCESS = "DELETE_MASTER_BRAND_SUCCESS";
export const DELETE_MASTER_BRAND_FAIL = "DELETE_MASTER_BRAND_FAIL";

export const REQUEST_DETAIL_MASTER_BRAND_START = "REQUEST_DETAIL_MASTER_BRAND_START";
export const REQUEST_DETAIL_MASTER_BRAND_SUCCESS = "REQUEST_DETAIL_MASTER_BRAND_SUCCESS";
export const REQUEST_DETAIL_MASTER_BRAND_FAIL = "REQUEST_DETAIL_MASTER_BRAND_FAIL";

export const PUT_MASTER_BRAND_START = "PUT_MASTER_BRAND_START";
export const PUT_MASTER_BRAND_SUCCESS = "PUT_MASTER_BRAND_SUCCESS";
export const PUT_MASTER_BRAND_FAIL = "PUT_MASTER_BRAND_FAIL";

export const DELETE_MULTIPLE_MASTER_BRAND_START = "DELETE_MULTIPLE_MASTER_BRAND_START";
export const DELETE_MULTIPLE_MASTER_BRAND_SUCCESS = "DELETE_MULTIPLE_MASTER_BRAND_SUCCESS";
export const DELETE_MULTIPLE_MASTER_BRAND_FAIL = "DELETE_MULTIPLE_MASTER_BRAND_FAIL";

export const PATCH_MULTIPLE_MASTER_BRAND_START = "PATCH_MULTIPLE_MASTER_BRAND_START";
export const PATCH_MULTIPLE_MASTER_BRAND_SUCCESS = "PATCH_MULTIPLE_MASTER_BRAND_SUCCESS";
export const PATCH_MULTIPLE_MASTER_BRAND_FAIL = "PATCH_MULTIPLE_MASTER_BRAND_FAIL";

export const PUT_MULTIPLE_MASTER_BRAND_START = "PUT_MULTIPLE_MASTER_BRAND_START";
export const PUT_MULTIPLE_MASTER_BRAND_SUCCESS = "PUT_MULTIPLE_MASTER_BRAND_SUCCESS";
export const PUT_MULTIPLE_MASTER_BRAND_FAIL = "PUT_MULTIPLE_MASTER_BRAND_FAIL";

export const REQUEST_MASTER_BRAND_PRODUCT_START = "REQUEST_MASTER_BRAND_PRODUCT_START"
export const REQUEST_MASTER_BRAND_PRODUCT_SUCCESS = "REQUEST_MASTER_BRAND_PRODUCT_SUCCESS"
export const REQUEST_MASTER_BRAND_PRODUCT_FAIL = "REQUEST_MASTER_BRAND_PRODUCT_FAIL"

export const POST_MASTER_BRAND_PRODUCT_START = "POST_MASTER_BRAND_PRODUCT_START"
export const POST_MASTER_BRAND_PRODUCT_SUCCESS = "POST_MASTER_BRAND_PRODUCT_SUCCESS"
export const POST_MASTER_BRAND_PRODUCT_FAIL = "POST_MASTER_BRAND_PRODUCT_FAIL"

export const POST_MULTIPLE_MASTER_BRAND_PRODUCT_START = "POST_MULTIPLE_MASTER_BRAND_PRODUCT_START";
export const POST_MULTIPLE_MASTER_BRAND_PRODUCT_SUCCESS = "POST_MULTIPLE_MASTER_BRAND_PRODUCT_SUCCESS";
export const POST_MULTIPLE_MASTER_BRAND_PRODUCT_FAIL = "POST_MULTIPLE_MASTER_BRAND_PRODUCT_FAIL";

export const DELETE_MASTER_BRAND_PRODUCT_START = "DELETE_MASTER_BRAND_PRODUCT_START"
export const DELETE_MASTER_BRAND_PRODUCT_SUCCESS = "DELETE_MASTER_BRAND_PRODUCT_SUCCESS"
export const DELETE_MASTER_BRAND_PRODUCT_FAIL = "DELETE_MASTER_BRAND_PRODUCT_FAIL"

export const IMPORT_MASTER_BRAND_START = "IMPORT_MASTER_BRAND_START";
export const IMPORT_MASTER_BRAND_SUCCESS = "IMPORT_MASTER_BRAND_SUCCESS";
export const IMPORT_MASTER_BRAND_FAIL = "IMPORT_MASTER_BRAND_FAIL";

export const REQUEST_IMPORT_MASTER_BRAND_START = "REQUEST_IMPORT_MASTER_BRAND_START";
export const REQUEST_IMPORT_MASTER_BRAND_SUCCESS = "REQUEST_IMPORT_MASTER_BRAND_SUCCESS";
export const REQUEST_IMPORT_MASTER_BRAND_FAIL = "REQUEST_IMPORT_MASTER_BRAND_FAIL";

export const {

    initMasterBrandInfo,
    requestMasterBrandStart,
    requestMasterBrandSuccess,
    requestAllMasterBrandSuccess,
    requestMasterBrandFail,

    postMasterBrandStart,
    postMasterBrandSuccess,
    postMasterBrandFail,

    patchMasterBrandStart,
    patchMasterBrandSuccess,

    deleteMasterBrandStart,
    deleteMasterBrandSuccess,
    deleteMasterBrandFail,

    requestDetailMasterBrandStart,
    requestDetailMasterBrandSuccess,
    requestDetailMasterBrandFail,

    putMasterBrandStart,
    putMasterBrandSuccess,
    putMasterBrandFail,

    deleteMultipleMasterBrandStart,
    deleteMultipleMasterBrandSuccess,
    deleteMultipleMasterBrandFail,

    patchMultipleMasterBrandStart,
    patchMultipleMasterBrandSuccess,
    patchMultipleMasterBrandFail,

    putMultipleMasterBrandStart,
    putMultipleMasterBrandSuccess,
    putMultipleMasterBrandFail,

    requestMasterBrandProductStart,
    requestMasterBrandProductSuccess,
    requestMasterBrandProductFail,

    postMasterBrandProductStart,
    postMasterBrandProductSuccess,
    postMasterBrandProductFail,

    postMultipleMasterBrandProductStart,
    postMultipleMasterBrandProductSuccess,
    postMultipleMasterBrandProductFail,

    deleteMasterBrandProductStart,
    deleteMasterBrandProductSuccess,
    deleteMasterBrandProductFail,

    importMasterBrandStart,
    importMasterBrandSuccess,
    importMasterBrandFail,

    requestImportMasterBrandStart,
    requestImportMasterBrandSuccess,
    requestImportMasterBrandFail,

} = createActions({

    [INIT_MASTER_BRAND_INFO]: (req) => ({ req }),

    [REQUEST_MASTER_BRAND_START]: (req) => ({ ...req }),
    [REQUEST_MASTER_BRAND_SUCCESS]: (res) => ({ res }),
    [REQUEST_ALL_MASTER_BRAND_SUCCESS]: (res) => ({ res }),
    [REQUEST_MASTER_BRAND_FAIL]: (res) => ({ res }),

    [POST_MASTER_BRAND_START]: (req) => ({ ...req }),
    [POST_MASTER_BRAND_SUCCESS]: (res) => ({ res }),
    [POST_MASTER_BRAND_FAIL]: (res) => ({ res }),

    [PATCH_MASTER_BRAND_START]: (req) => ({ ...req }),
    [PATCH_MASTER_BRAND_SUCCESS]: (res) => ({ res }),

    [DELETE_MASTER_BRAND_START]: (req) => ({ ...req }),
    [DELETE_MASTER_BRAND_SUCCESS]: (res) => ({ res }),
    [DELETE_MASTER_BRAND_FAIL]: (res) => ({ res }),

    [REQUEST_DETAIL_MASTER_BRAND_START]: (req) => ({ ...req }),
    [REQUEST_DETAIL_MASTER_BRAND_SUCCESS]: (res) => ({ res }),
    [REQUEST_DETAIL_MASTER_BRAND_FAIL]: (res) => ({ res }),

    [PUT_MASTER_BRAND_START]: (req) => ({ ...req }),
    [PUT_MASTER_BRAND_SUCCESS]: (res) => ({ res }),
    [PUT_MASTER_BRAND_FAIL]: (res) => ({ res }),

    [DELETE_MULTIPLE_MASTER_BRAND_START]: (req) => ({ ...req }),
    [DELETE_MULTIPLE_MASTER_BRAND_SUCCESS]: (res) => ({ res }),
    [DELETE_MULTIPLE_MASTER_BRAND_FAIL]: (res) => ({ res }),

    [PATCH_MULTIPLE_MASTER_BRAND_START]: (req) => ({ ...req }),
    [PATCH_MULTIPLE_MASTER_BRAND_SUCCESS]: (res) => ({ res }),
    [PATCH_MULTIPLE_MASTER_BRAND_FAIL]: (res) => ({ res }),

    [PUT_MULTIPLE_MASTER_BRAND_START]: (req) => ({ ...req }),
    [PUT_MULTIPLE_MASTER_BRAND_SUCCESS]: (res) => ({ res }),
    [PUT_MULTIPLE_MASTER_BRAND_FAIL]: (res) => ({ res }),

    [REQUEST_MASTER_BRAND_PRODUCT_START]: (req) => ({ ...req }),
    [REQUEST_MASTER_BRAND_PRODUCT_SUCCESS]: (res) => ({ res }),
    [REQUEST_MASTER_BRAND_PRODUCT_FAIL]: (res) => ({ res }),

    [POST_MASTER_BRAND_PRODUCT_START]: (req) => ({ ...req }),
    [POST_MASTER_BRAND_PRODUCT_SUCCESS]: (res) => ({ res }),
    [POST_MASTER_BRAND_PRODUCT_FAIL]: (res) => ({ res }),

    [POST_MULTIPLE_MASTER_BRAND_PRODUCT_START]: (req) => ({ ...req }),
    [POST_MULTIPLE_MASTER_BRAND_PRODUCT_SUCCESS]: (res) => ({ res }),
    [POST_MULTIPLE_MASTER_BRAND_PRODUCT_FAIL]: (res) => ({ res }),

    [DELETE_MASTER_BRAND_PRODUCT_START]: (req) => ({ ...req }),
    [DELETE_MASTER_BRAND_PRODUCT_SUCCESS]: (res) => ({ res }),
    [DELETE_MASTER_BRAND_PRODUCT_FAIL]: (res) => ({ res }),

    [IMPORT_MASTER_BRAND_START]: (req) => ({ ...req }),
    [IMPORT_MASTER_BRAND_SUCCESS]: (res) => ({ res }),
    [IMPORT_MASTER_BRAND_FAIL]: (res) => ({ res }),

    
    [REQUEST_IMPORT_MASTER_BRAND_START]: (req) => ({ ...req }),
    [REQUEST_IMPORT_MASTER_BRAND_SUCCESS]: (res) => ({ res }),
    [REQUEST_IMPORT_MASTER_BRAND_FAIL]: (res) => ({ res }),
})


